import { Component } from "react";
import View from "./view";
import "./index.css";

class Toggle extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.active = props.active
  }

  render() {
    return View.call(this);
  }
}

export default Toggle;



// WEBPACK FOOTER //
// ./src/components/toggle/index.js